import React from "react";
import Header from "@/components/Header";
import Pricing from "@/pages/Pricing";
import FAQAndContactSection from "@/components/home/FAQAndContactSection";
import Footer from "@/components/Footer";
import MaintenanceBanner from "@/components/MaintenanceBanner";
import BackToTop from "@/components/BackToTop";
import { SEO } from "@/components/SEO";

export default function PricingPage() {
  return (
    <div className="min-h-screen flex flex-col bg-white dark:bg-slate-950 text-slate-900 dark:text-slate-100">
      <SEO
        title="Planes y Precios Oficiales - Mi Asistente Legal IA"
        description="Tarifas claras y transparentes para despachos jurídicos, abogados independientes y copropiedades en Colombia."
      />
      <MaintenanceBanner />
      <Header />
      <main className="flex-grow pt-4 sm:pt-6">
        <Pricing />
        <FAQAndContactSection />
      </main>
      <Footer />
      <BackToTop />
    </div>
  );
}

